import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

export default function NotFoundPage() {
    return (
        <>
            <Navigation />
            <div className="container">
                <div className="row">
                    <div className="col col--12">
                        <div className="underlineTitle active">
                            <h1>
                                <slot>
                                    <strong>Oeps!</strong> Deze pagina konden we niet vinden.
                                </slot>
                            </h1>
                            <p>Vervolg je bezoek aan de website via het menu!</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
